import React from "react";

const ArtistTileCatalog = (props) => {
  const imagePath = require(`../assets/playlists/${props.artist.logo}`);

  const onTileClickHandler = () => {
    props.onClick(props.artist);
  };

  return (
    <div className="searchbar-artist" onClick={onTileClickHandler}>
      <div className="playlist-tile-wrapper">
          <img
            className="searchbar-image"
            src={imagePath}
            alt={props.artist.logo}
          />
        <div className="playlist-tile-text">{props.artist.name}</div>
      </div>
    </div>
  );
};

export default ArtistTileCatalog;
